import { useEffect } from 'react';

import { combo } from 'core';
import { useDispatch } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router';

export const useComboApplicationWrapper = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/combo' && searchParams.get('q')) {
      dispatch(combo.actions.comboFetch.request());
    }
  }, [location.pathname, searchParams.get('q')]);
};
